import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import * as firebase from 'firebase';
import {ToastService} from '../typescripts/pro/alerts'

@Component({
  selector: 'app-adminampa-informacion-crear',
  templateUrl: './adminampa-informacion-crear.component.html',
  styleUrls: ['./adminampa-informacion-crear.component.scss']
})
export class AdminampaInformacionCrearComponent implements OnInit {

  datosdisponibles: boolean = false;
  state = 'crear';
  objectId;
  user;
  userId;
  id;



  nombre;
  direccion;
  direccionform
  telefono;
  lat;
  lng;
  url;
  email;
  codigo_postal;
  poblacion;
  provincia;
  date_registered;
  descripcion;
  imagen;

  optionsSelectTipo: Array<any>;
  selectedfilename;

  //downloadUrl;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _location: Location,
    private toast: ToastService,
  ) {
    //INICIALIZACIONES

    //comprobamos si estamos pasando parametros por la url para editar o ver un documento
    this.route.params.subscribe(params => {
        if(params.state){
          if(params.state === 'editar'){
                this.state = 'editar';
          } else if(params.state === 'ver'){
                  this.state = 'ver';
              }
              this.objectId = params.id

              console.log('this state: ', this.state)
              console.log('objectId id: ', this.objectId)
        }
    })

    //obtener datos del usuario admin logueado para saber a que AMPA pertenece
    this.userId = localStorage.getItem('userId');
    console.log('UserId', this.userId);
    if(!this.userId){
      this.router.navigate[('')]
    } else {
      firebase.firestore().collection('admins').doc(this.userId)
      .get()
      .then((doc)=>{
        this.user = doc.data();
        console.log('User ampa-informacion-crear', this.user)
        console.log('user ampa ampa-informacion-crear', this.user.ampa)
        this.obtenerAMPAInformacion();
      })
    }
  }


  ngOnInit() {}

 // nos traemos los ampainformacion del ampa utilizando el id de ampa
 //que tiene el usuario en su documento
 obtenerAMPAInformacion(){
   console.log('obtenerAMPAInformacion')
   firebase.firestore().collection('ampas')
   .where('ampa','==', this.user.ampa)
   .get()
   .then(snapshot => {
       snapshot.forEach(doc => {
           var elemento = doc.data();
           console.log('ampainformacion: ',doc.data())
           if (elemento == undefined)
                   this.state = 'crear'
           else {
             //this.state = 'ver';
             this.id = doc.id;
             this.nombre= elemento.nombre || '';
             this.direccion= elemento.direccion || '';
             this.direccionform= elemento.direccionform || '';
             this.telefono= elemento.telefono || '';
             this.lat= elemento.lat || '';
             this.lng= elemento.lng || '';
             this.url= elemento.url || '';
             this.email= elemento.email || '';
             this.codigo_postal= elemento.codigo_postal || '';
             this.poblacion= elemento.poblacion || '';
             this.provincia= elemento.provincia || '';
             this.date_registered= elemento.date_registered || '';
             this.descripcion= elemento.descripcion || '';
             this.imagen= elemento.imagen || 'https://firebasestorage.googleapis.com/v0/b/miampa-1be3e.appspot.com/o/compartido%2Fcolegio-foto.jpg?alt=media&token=545ebfe0-ffbe-46a3-bf9b-e85ea4256358';
           }
       });
   })
   .catch(err => {
       console.log('Error getting documents', err);
   });

   this.datosdisponibles = true;

 }

  //guardar datos de ampa cuando se crea
  guardar(){
    var now = new Date()
    firebase.firestore().collection('ampas').add({
      ampa: this.user.ampa || '',
      nombre: this.nombre || '',
      direccion: this.direccion || '',
      direccionform: this.direccionform || '',
      telefono: this.telefono || '',
      lat: this.lat || '',
      lng: this.lng || '',
      url: this.url || '',
      email: this.email || '',
      codigo_postal: this.codigo_postal || '',
      poblacion: this.poblacion || '',
      provincia: this.provincia || '',
      date_registered: now || '',
      descripcion: this.descripcion || '',
      imagen: this.imagen || 'https://firebasestorage.googleapis.com/v0/b/miampa-1be3e.appspot.com/o/compartido%2Fcolegio-foto.jpg?alt=media&token=545ebfe0-ffbe-46a3-bf9b-e85ea4256358',
    })
    .then((docRef)=>{
      if (docRef)
        console.log('Creado ', docRef.id)
      this.showSuccess('Datos guardatos correctamente.');
      this.router.navigate(['/admin/ampa-informacion'])
    })
  }

  // actualizamos los datos de algunos campos del ampa
  editar(){
  var now = new Date()
  firebase.firestore().collection('ampas').doc(this.objectId).update({
    ampa: this.user.ampa || '',
    nombre: this.nombre || '',
    direccion: this.direccion || '',
    direccionform: this.direccionform || '',
    telefono: this.telefono || '',
    lat: this.lat || '',
    lng: this.lng || '',
    url: this.url || '',
    email: this.email || '',
    codigo_postal: this.codigo_postal || '',
    poblacion: this.poblacion || '',
    provincia: this.provincia || '',
    date_registered: now || '',
    descripcion: this.descripcion || '',
    imagen: this.imagen || 'https://firebasestorage.googleapis.com/v0/b/miampa-1be3e.appspot.com/o/compartido%2Fcolegio-foto.jpg?alt=media&token=545ebfe0-ffbe-46a3-bf9b-e85ea4256358',
  })
  .then((docRef)=>{
    if (docRef)
      console.log('Datos guardatos correctamente. ', docRef);
      //this.obtenerAMPAInformacion();
      this.showSuccess('Datos guardatos correctamente.');
      this.router.navigate(['/admin/ampa-informacion'])
  })
  .catch(error => {
    console.log(error);
    this.showError('Hubo algún problema guardando los cambios.');
  })
  }


  volver(){
    this._location.back();
  }


  selectedFile(fileInput: Event){

    let target = <HTMLInputElement>fileInput.target;
    let files = target.files;
    let file = files.item(0);

    var storage = firebase.storage();
    var storageRef = storage.ref();

    var imagesRef = storageRef.child('ampas/'+ this.user.ampa + '/' + file.name );
    this.selectedfilename = file.name;
    imagesRef.put(file)
    .then((snapshot)=>{
      this.imagen = snapshot.downloadURL;
    })
  }



    //metodos de toast para el usuario
    showSuccess(mensaje) {
      //let options = { closeButton: true, tapToDismiss: false,  titleClass: 'yellow' };
      //this.toast.success(mensaje, 'Toastr success!', options);
      this.toast.success(mensaje);
    }

    showError(mensaje) {
      //let options = { enableHtml: false,  positionClass: 'toast-bottom-right' };
      //this.toast.error(mensaje, 'Toastr error!', options);
      this.toast.error(mensaje);
    }

    showInfo(mensaje) {
      //let options = { extendedTimeOut: 30000, messageClass: 'pink' };
      //this.toast.info('Info message', 'Toastr info!', options);
      this.toast.info(mensaje);
    }

    showWarning(mensaje) {
      //let options = { progressBar: true,  timeOut: 3000,  toastClass: 'black'};
      //this.toast.warning('Warnig message', 'Toastr warning!', options);
      this.toast.warning(mensaje);
    }

}



// WEBPACK FOOTER //
// ./src/app/adminampa-informacion-crear/adminampa-informacion-crear.component.ts